import {
  PickerOptions,
  PickerFileMetadata,
  PickerUploadDoneCallback,
} from "filestack-js";

import { MediaType } from "@teachers/easel-media";

export const containerIds: Record<MediaType, string> = {
  [MediaType.Audio]: "audio-upload-filestack-picker",
};

const audioConfig: PickerOptions = {
  accept: "audio/*",
  customText: {
    "Select Files to Upload": "Drop audio file here",
    "or Drag and Drop, Copy and Paste Files": "or click to select",
    "Deselect All": "Remove",
  },
  container: `#${containerIds[MediaType.Audio]}`,
};

export const filestackConfig = {
  [MediaType.Audio]: audioConfig,
};

export type UploadFailedCallback = (
  file: PickerFileMetadata,
  error: Error
) => void;

export type UploadCompleteCallback = PickerUploadDoneCallback;

export interface PickerStoreOptions {
  location?: "s3";
  path?: string;
}

export interface MediaUploadModalProps {
  showModal: boolean;
  onHide: () => void;
  apiKey: string;
  storageOptions?: PickerStoreOptions;
  onUploadDone: UploadCompleteCallback;
  onUploadFailed: UploadFailedCallback;
  mediaType: MediaType;
}

export type FilestackHookProps = Omit<MediaUploadModalProps, "showModal">;
